namespace Matrix.Administration {
    export interface UserRoleListResponse extends Serenity.ListResponse<string> {
    }
}
